// @auto-index

import Resume from './Resume'

export { default as bio } from './bio'
export { default as companies } from './companies'
export { default as contracts } from './contracts'
export { default as goals } from './goals'
export { default as interests } from './interests'
export { default as LOCALE } from './LOCALE'
export { default as projects } from './projects'
export { default as Resume } from './Resume'
export { default as routes } from './routes'
export { default as sections } from './sections'
export { default as skills } from './skills'
export { default as styles } from './styles'
export { default as tech } from './tech'

export default Resume
